@if (label && usesFloatLabel()) {
  <p-floatLabel>
    <ng-template [ngTemplateOutlet]="dropdown"></ng-template>
    <label [for]="inputId">{{ label }}</label>
  </p-floatLabel>
} @else {
  <ng-template [ngTemplateOutlet]="dropdown"></ng-template>
}

<ng-template #dropdown>
  <p-multiSelect
    #multiSelect
    [options]="_options | orderBy: sort | orderBy: (isFilterSelectedItems ? '-isSelected:boolean' : null)"
    [ngModel]="_selectedItems"
    (ngModelChange)="onModelChange($event)"
    (onPanelHide)="onPanelHide()"
    (onPanelShow)="panelShow.emit(); openedChange.emit(true)"
    (onLazyLoad)="onLazyLoad.emit($event)"
    (onClear)="onClear()"
    (onFilter)="onFilterItems($event)"
    [maxSelectedLabels]="effectiveMaxSelectedLabels"
    [placeholder]="inputPlaceholder()"
    [inputId]="inputId"
    [showHeader]="showHeader"
    [filterBy]="filterBy"
    dropdownIcon="pi pi-chevron-down"
    [showToggleAll]="showToggleAll"
    styleClass="w-full {{ styleClass }}"
    [emptyFilterMessage]="emptyFilterMessage"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [dataKey]="optionValue"
    [disabled]="disabled"
    [class]="(isError ? 'ng-invalid ng-dirty ' : '') + class"
    [group]="group"
    [appendTo]="appendTo || 'body'"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    [emptyMessage]="emptyMessage"
    [scrollHeight]="scrollHeight"
    [optionDisabled]="optionDisabled"
    [selectedItemsLabel]="selectedItemsLabel"
    [panelStyle]="panelStyle"
    [panelStyleClass]="mergedPanelStyleClass"
    [lazy]="lazy"
    [display]="multiSelectDisplay"
    [showClear]="showClear"
    [loading]="loading">
    @if (groupTemplate) {
      <ng-template
        let-group
        pTemplate="group">
        <ng-template
          [ngTemplateOutlet]="groupTemplate"
          [ngTemplateOutletContext]="{ group: group }"></ng-template>
      </ng-template>
    }

    @if (!isDisplayChip) {
      <ng-template pTemplate="selectedItems">
        <div>
          @if (!_selectedItems || _selectedItems.length === 0) {
            {{ inputPlaceholder() }}
          }

          @if (_selectedItems?.length > effectiveMaxSelectedLabels) {
            {{ selectedItemsLabel.replace(replaceRegExp, _selectedItems.length.toString()) }}
          } @else {
            @if (selectedItemsTemplate || isTemplateCombined) {
              <ng-template
                [ngTemplateOutlet]="isTemplateCombined ? selectedItemsTemplate || itemTemplate : selectedItemsTemplate"
                [ngTemplateOutletContext]="{
                  items: _selectedItems | filterBySelectedItems: _options : optionValue : group
                }"></ng-template>
            } @else {
              @for (
                item of _selectedItems | filterBySelectedItems: _options : optionValue : group | orderBy: optionLabel;
                track item;
                let isLast = $last
              ) {
                <span>{{ item | nestedProperty: optionLabel }}{{ !isLast ? ', ' : '' }}</span>
              }
            }
          }
        </div>
      </ng-template>
    }

    <ng-template
      let-item
      pTemplate="item">
      @if (itemTemplate) {
        <ng-template
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ item: item }"></ng-template>
      } @else {
        <div>
          <div [ngClass]="itemStyleClass">
            <span [innerHTML]="highlightMatchText(item | nestedProperty: optionLabel) | safeHtml"></span>
          </div>

          @if (itemDescriptionField) {
            <div class="frm-color-green">
              {{ item | nestedProperty: itemDescriptionField }}
            </div>
          }

          @if (itemSubDescriptionField) {
            <div class="frm-color-blue-light text-xs">
              {{ item | nestedProperty: itemSubDescriptionField }}
            </div>
          }
        </div>
      }
    </ng-template>

    @if (footerTemplate) {
      <ng-template pTemplate="footer">
        <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
      </ng-template>
    }
  </p-multiSelect>
</ng-template>
